import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

export interface MapFeature {
  type: string;
  geometry: {
    type: string;
    coordinates: [number, number];
  };
  properties: {
    extent: [number, number, number, number];
    country: string;
    city: string;
    district: string;
    locality: string;
    state: string;
    name: string;
    county: string;
    [key: string]: unknown;
  };
}

export interface MapSearchResponse {
  type: string;
  features: MapFeature[];
}

export interface MapSearchParams {
  q: string;
  limit?: number;
  lang?: string;
}

@Injectable({
  providedIn: 'root',
})
export class MapSearchApiService {
  private readonly http = inject(HttpClient);

  search(params: MapSearchParams): Observable<MapFeature[]> {
    const httpParams = new HttpParams({
      fromObject: {
        q: params.q,
        limit: String(params.limit ?? 10),
        lang: params.lang ?? 'default',
      },
    });

    return this.http
      .get(`${environment.mapSearchApiUrl}search`, {
        params: httpParams,
        responseType: 'text',
      })
      .pipe(
        map((response: string) => JSON.parse(response) as MapSearchResponse),
        map((response) => response.features ?? []),
      );
  }
}
